<template>
  <export-email-report-dialog
    button-text="Exportar contatos"
    title="Enviar relatório de contatos do Whatsapp"
    description="O relatório da lista completa de contatos do Whatsapp é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo CSV contendo todas as informações detalhadas da lista completa de contatos do Whatsapp é enviado em anexo ao e-mail."
    :exportReportFn="exportReport"
    async
    disableXLSX
    @file-format="getFileFormat"
  />
</template>

<script>
import { MUTATION_EXPORT_WHATSAPP_CONTACTS_REPORT } from '@/modules/campanhas/whatsapp/graphql'

import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
export default {
  name: 'ExportRaffleParticipantsDialog',
  components: {
    ExportEmailReportDialog,
  },
  props: {
    filters: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    fileFormat: 'CSV',
  }),
  methods: {
    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportReport(emails) {
      return this.$apollo.mutate({
        mutation: MUTATION_EXPORT_WHATSAPP_CONTACTS_REPORT,
        fetchPolicy: 'no-cache',
        variables: {
          emails,
          fileFormat: this.fileFormat,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
  },
}
</script>
